/**
 * Safely parse JSON response, returning null on error
 */
export function safeParseJson(res) {
  return res
    .json()
    .catch(() => null)
    .then((body) => body);
}

/**
 * Fetch and parse JSON with error handling
 */
export async function fetchJson(url, opts) {
  const res = await fetch(url, opts);
  const body = await safeParseJson(res);
  return { 
    ok: res.ok, 
    status: res.status, 
    statusText: res.statusText, 
    body 
  };
}

/**
 * Extract return URL from nested response structure
 */
export function extractReturnUrl(body) {
  return body?.body?.data?.returnUrl ?? body?.data?.returnUrl ?? body?.returnUrl;
}

/**
 * Extract error message from API response
 */
export function extractErrorMessage(body, status, statusText) {
  return body?.message || body?.error || `HTTP ${status}: ${statusText}`;
}